export enum CommandHandelingState {
  Queued,
  InProgress,
  Failed,
  Success,
  Finished,
  DescriptionFailed,
  Pending,
}
